import PreviousLink from "./PreviousLink.jsx"
import NextLink from "./NextLink.jsx"
import PageLink from "./PageLink.jsx"
import CurrentPage from "./CurrentPage.jsx"
import Ellipsis from "./Ellipsis.jsx"

export default function Pagination({pagination, ...props}) {

  return (
    <>
      {pagination && pagination["serie"] && pagination["serie"].length > 0 && (
      <div className="relative container mx-auto p-6 flex items-center justify-between lg:w-full">
        <ul className="flex items-center -space-x-px h-8 text-sm mx-auto">
          <PreviousLink prevPage={pagination.prev} onPaginationClick={props.onPaginationClick} />
          {
            pagination["serie"].map((page) => {
              if (page === pagination.page) {
                return <CurrentPage key={"current-page-" + page} page={page} />
              } else if (page === "...") {
                return <Ellipsis key={"ellipsis-" + page} />
              } else {
                return <PageLink key={"page-link-" + page} page={page} currentPage={pagination.current} onPaginationClick={props.onPaginationClick} />
              }
            })
          }
          <NextLink nextPage={pagination.next} onPaginationClick={props.onPaginationClick} />
        </ul>
      </div>
      )}
    </>
  )
}
